import { ReactChild } from 'react'
import useHasPermiso from '../../hooks/autenticacion/useHasPermiso'

type Props = {
  children: ReactChild
  rolMostrarPorPermiso: string[]
}

/**
 * Oculta acciones de interfaz cuando el usuario no tiene el rol requerido.
 *
 * Se usa para botones y controles de escritura. La seguridad real debe seguir
 * validandose en backend, porque este componente solo afecta visibilidad en UI.
 */
const ComponentePrivado = ({ children, rolMostrarPorPermiso }: Props) => {
  const { hasPermiso } = useHasPermiso()
  if (!hasPermiso(rolMostrarPorPermiso)) return <></>
  return <>{children}</>
}

export default ComponentePrivado
